import type { Client } from '@core/api/utils';
import { pipeDataTwice } from '@core/api/utils';
import { toStoreSlug } from '@core/stores/Store';
import { PlanType } from '../models';
import toSubscriptionPlans from './mappers';

export const toSubscriptionPlansUrl = (planType: PlanType, postalCode?: string) =>
  postalCode
    ? `/ecomm/store/${toStoreSlug()}/${planType}_subscriptions/plans?postal_code=${postalCode}`
    : `/ecomm/store/${toStoreSlug()}/${planType}_subscriptions/plans`;

export const fetchDigitalSubs = (api: Client, postalCode?: string) =>
  api
    .get(toSubscriptionPlansUrl(PlanType.Digital, postalCode))
    .then(pipeDataTwice(toSubscriptionPlans));
